import styled from "styled-components";

export const GeneralSettingsFormStyles = styled.div`
  max-width: 960px;

  form {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[20]};
  }

  .fieldRow {
    display: flex;
    align-items: flex-start;
    gap: ${({ theme }) => theme.spacing[24]};

    > * {
      flex: 1;
    }
  }

  .fieldGroup {
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[4]};
  }

  .fieldInline {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .fieldCompact {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[12]};
  }

  .equipmentButtons {
    display: flex;
    gap: ${({ theme }) => theme.spacing[12]};
    flex-wrap: wrap;
  }

  .amenitiesCheckboxes {
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing[12]};
    margin-top: ${({ theme }) => theme.spacing[4]};
  }

  .cardHeaderRow {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
  }

  @keyframes fadeSlideIn {
    from {
      opacity: 0;
      transform: translateY(-50%) translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateY(-50%) translateX(0);
    }
  }

  .sectionSaveBtn {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    animation: fadeSlideIn 0.25s ease-out;
  }

  .dragAndDropText {
    font-size: 12px;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin: 2px 0 8px 0;
  }
`;
